import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Toast from '../components/Toast';
import { useApp } from '../data/ColisContext';
import { BRAND } from '../data/constants';

export default function ComptePage() {
  const { user, updateMe } = useApp();
  const isMobile = typeof window !== 'undefined'
    ? window.matchMedia && window.matchMedia('(max-width: 640px)').matches
    : false;

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setName(user?.name || '');
    setEmail(user?.email || '');
    setPhone(user?.phone || '');
  }, [user?.name, user?.email, user?.phone]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      await updateMe({
        name: (name || '').trim(),
        email: (email || '').trim().toLowerCase(),
        phone: (phone || '').trim(),
      });
    } catch (err) {
      setError(err?.message || 'Erreur lors de la mise à jour');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />

      <main style={{ maxWidth: 720, margin: '0 auto', padding: isMobile ? '28px 14px' : '40px 20px' }}>
        <h1 style={{ fontSize: 26, fontWeight: 900, color: '#0f172a', margin: '0 0 6px' }}>Mon compte</h1>
        <div style={{ fontSize: 14, color: '#64748b', marginBottom: 18 }}>Modifie tes informations de connexion.</div>

        {error && (
          <div style={{ background: '#FEE2E2', color: '#B91C1C', padding: '10px 12px', borderRadius: 12, fontWeight: 700, fontSize: 13, marginBottom: 14 }}>
            {error}
          </div>
        )}

        <div style={{ background: 'white', borderRadius: 18, padding: isMobile ? 14 : 18, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid #f0f0f0' }}>
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <label style={{ fontWeight: 800, fontSize: 13, color: '#334155' }}>
              Nom
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
                required
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <label style={{ fontWeight: 800, fontSize: 13, color: '#334155' }}>
              Email
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <label style={{ fontWeight: 800, fontSize: 13, color: '#334155' }}>
              Téléphone
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                type="tel"
                placeholder="Ex: 77 123 45 67"
                style={{ width: '100%', marginTop: 6, padding: '12px 14px', borderRadius: 12, border: '2px solid #e2e8f0', outline: 'none', fontFamily: 'inherit' }}
              />
            </label>

            <button
              type="submit"
              disabled={saving}
              style={{
                marginTop: 10,
                padding: '14px 16px',
                borderRadius: 14,
                border: 'none',
                cursor: saving ? 'not-allowed' : 'pointer',
                fontWeight: 900,
                color: 'white',
                background: BRAND.gradient,
                boxShadow: '0 6px 20px rgba(79,70,229,0.25)',
                fontFamily: 'inherit',
                opacity: saving ? 0.7 : 1,
              }}
            >
              {saving ? 'Enregistrement…' : 'Enregistrer'}
            </button>
          </form>
        </div>
      </main>

      <Toast />
    </div>
  );
}
